<template>
    <div class="page-portfolio">
        <div class="jumbo-wrapper portfolio">
            <div class="jumbo-main">
                <div class="jumbo-content">
                    <p class="t15">PORTFOLIO</p>
                    <h2 class="t42">
                        32+ YEARS OF PROJECTS
                        <br/>
                        ACROSS THE COUNTRY
                    </h2>
                    <p class="t20">Start one in your community today!</p>
                </div>
            </div>
        </div>
        <div class="box-content portfolio">
            <slot class="box-content-inner"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Portfolio'
    };
</script>


// WEBPACK FOOTER //
// Portfolio.vue?68222630